export default __webpack_public_path__ + "static/media/requisiciones-mantenimiento.434ca71e.png";